// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"4DmIA":[function(require,module,exports) {
/**
 * Created By Hensi Murcia
 */ var _common = require("./common");
"use strict";
//Initialize elements
var btnLogin = document.getElementById("btnLogin");
var etEmail = document.getElementById("etEmail");
var etPassword = document.getElementById("etPassword");
var loader = document.getElementById("loading");
var btnPhoneLogin = document.getElementById("btnPhoneLogin");
var btnEmailLogin = document.getElementById("btnEmailLogin");
var divEmailOptions = document.getElementById("emailOptions");
var divPhoneOptions = document.getElementById("phoneOptions");
var ui = new firebaseui.auth.AuthUI(firebase.auth());
var trans;
$(document).ready(function() {
    $(function() {
        translatePage();
        initClickListeners();
        initFirebaseUi();
        window.onclick = function(event) {
            if (!event.target.matches(".dropbtn")) {
                var dropdowns = document.getElementsByClassName("dropdown-content");
                var i;
                for(i = 0; i < dropdowns.length; i++){
                    var openDropdown = dropdowns[i];
                    if (openDropdown.classList.contains("show")) openDropdown.classList.remove("show");
                }
            }
        };
        btnLogin.addEventListener("click", login);
        etPassword.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                //"Enter" key on keyboard
                //cancel the deafult button if needed
                event.preventDefault();
                btnLogin.click();
            }
        });
        btnNext.addEventListener("click", function() {
            checkEmail(etEmail.value);
        });
        etEmail.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                //cancel the deafult button if needed
                event.preventDefault();
                btnNext.click();
                etPassword.focus();
            }
        });
        btnRegister.addEventListener("click", function() {
            var email = etEmail.value.trim();
            var pass = etPassword.value.trim();
            if (pass && email) {
                (0, _common.setDisplay)(loading, "block");
                firebase.auth().createUserWithEmailAndPassword(email, pass).then(function(user) {
                    if (user) (0, _common.setDisplay)(loading, "none");
                    else {
                        (0, _common.showToast)(trans.errorRegister);
                        (0, _common.setDisplay)(loading, "none");
                    }
                }).catch(function(error) {
                    // Handle Errors here.
                    var errorMessage = error.message;
                    (0, _common.showToast)(errorMessage);
                    (0, _common.setDisplay)(loading, "none");
                });
            }
        });
        btnEmailLogin.addEventListener("click", function() {
            (0, _common.setDisplay)(divEmailOptions, "block");
            (0, _common.setDisplay)(divPhoneOptions, "none");
        }, false);
        btnPhoneLogin.addEventListener("click", function() {
            (0, _common.setDisplay)(divEmailOptions, "none");
            (0, _common.setDisplay)(divPhoneOptions, "block");
        }, false);
    });
});
function initClickListeners() {
    btnTranslate.addEventListener("click", function() {
        showDropdown();
    });
    aEn.addEventListener("click", function() {
        translatePage("en");
    });
    aEs.addEventListener("click", function() {
        translatePage("es");
    });
    myModal.querySelector(".close").addEventListener("click", function() {
        (0, _common.closeMyModal)();
    });
    myModal.querySelector(".btnBlue").addEventListener("click", function() {
        (0, _common.closeMyModal)();
    });
}
function showDropdown() {
    document.getElementById("langDropdown").classList.toggle("show");
}
/**
 * Init Firebase phone ui
 */ function initFirebaseUi() {
    ui.start(divPhoneOptions, {
        signInOptions: [
            {
                provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
                recaptchaParameters: {
                    type: "image",
                    size: "normal",
                    badge: "bottomleft"
                }
            }
        ]
    });
}
/**
 * check if user logged in
 */ firebase.auth().onAuthStateChanged(function(user) {
    if (user) {
        // User is signed in.
        toggleLoader(true);
        if (window.location.search.includes("action=manage")) window.location.replace("../removeAccount.html?action=success");
        else window.location.replace("../chat.html");
    }
});
/**
 * function login()
 * logs in user to firebase
 */ function login() {
    toggleLoader(false);
    var email = etEmail.value;
    var password = etPassword.value;
    if (!document.getElementById("cbRememberMe").checked) firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then(function() {
        // Existing and future Auth states are now persisted in the current
        // session only. Closing the window would clear any existing state even
        // if a user forgets to sign out.
        // ...
        // New sign-in will be persisted with session persistence.
        return firebase.auth().signInWithEmailAndPassword(email, password);
    }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        toggleLoader(true);
        (0, _common.setModalMessage)("Error " + errorCode + ": " + errorMessage);
        (0, _common.openCommonModal)();
    });
    else firebase.auth().signInWithEmailAndPassword(email, password).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        toggleLoader(true);
        (0, _common.setModalMessage)("Error " + errorCode + ": " + errorMessage);
        (0, _common.openCommonModal)();
    //window.alert('Error ' + errorCode + ": " + errorMessage);
    });
}
function toggleLoader(hide) {
    if (hide) loader.style.display = "none";
    else loader.style.display = "block";
}
function checkEmail(email) {
    firebase.auth().fetchSignInMethodsForEmail(email).then(function(signInMethods) {
        (0, _common.setDisplay)(btnNext, "none");
        (0, _common.setDisplay)(etPassword, "block");
        if (signInMethods.indexOf(firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD) != -1) {
            (0, _common.setDisplay)(divPassInfo, "block");
            divPassInfo.textContent = trans.welcomeBack;
            etPassword.placeholder = trans.password;
            (0, _common.setDisplay)(btnLogin, "block");
            (0, _common.setDisplay)(btnRegister, "none");
            var checkMark = emailOptions.querySelector(".check");
            (0, _common.setDisplay)(checkMark, "block");
        // User can sign in with email/password.
        } else {
            (0, _common.setDisplay)(divPassInfo, "block");
            divPassInfo.textContent = trans.createPass;
            etPassword.placeholder = trans.anyPass;
            (0, _common.setDisplay)(btnLogin, "none");
            (0, _common.setDisplay)(btnRegister, "block");
            var checkMark = emailOptions.querySelector(".check");
            (0, _common.setDisplay)(checkMark, "none");
        }
        (0, _common.setDisplay)(loading, "none");
        etPassword.focus();
    }).catch(function(error) {
        (0, _common.showToast)(error);
        (0, _common.setDisplay)(loading, "none");
    // Some error occurred, you can inspect the code: error.code
    });
}
var language = {
    eng: {
        welcome: "Welcome",
        messageLogout: "Are you sure you want to logout?",
        initSession: "Login using the easiest option for you",
        phone: "Phone",
        email: "email",
        password: "Password",
        remember: "Remember me",
        login: "Login",
        disclaimer: 'By continuing, you agree to our <a href="about.html#terms">Terms and Conditions</a>, and <a href="about.html">Privacy policy</a>',
        welcomeBack: "Welcome back! Enter the password for this account",
        anyPass: "Enter any password",
        idiom: "En"
    },
    es: {
        welcome: "Bienvenid@",
        messageLogout: "\xbfEst\xe1s segur@ de que quieres cerrar sesi\xf3n?",
        initSession: "Inicia sesi\xf3n con la opci\xf3n m\xe1s f\xe1cil para ti",
        phone: "Tel\xe9fono",
        email: "Correo electr\xf3nico",
        password: "Contrase\xf1a",
        remember: "Recu\xe9rdame",
        login: "Iniciar sesi\xf3n",
        disclaimer: 'Al continuar, aceptas nuestros <a href="about.html#terms">T\xe9rminos y Condiciones</a>, y <a href="about.html">Pol\xedtica de Seguridad</a>',
        welcomeBack: "\xa1Bienvenido de nuevo! Ingrese la contrase\xf1a para esta cuenta",
        anyPass: "Cualquier contrase\xf1a",
        idiom: "Es"
    }
};
function translatePage(lang) {
    var translate = false;
    if (lang) {
        if (lang.includes("es")) {
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            aEn.className = aEn.className.replace(" set", "");
            aEs.className += " set";
            (0, _common.setCookie)("lang", "es", 365);
        } else {
            trans = language.eng;
            document.getElementsByTagName("html")[0].setAttribute("lang", "en");
            aEs.className = aEn.className.replace(" set", "");
            aEn.className += " set";
            (0, _common.setCookie)("lang", "en", 365);
        }
        translate = true;
    } else if ((0, _common.getCookie)("lang") != "") {
        if ((0, _common.getCookie)("lang").includes("es")) {
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            var langs = langDropdown.querySelectorAll("a");
            langs[0].className = langs[0].className.replace(" set", "");
            langs[1].className += " set";
            translate = true;
            (0, _common.setCookie)("lang", "es", 365);
        } else trans = language.eng;
    } else if (navigator.language && navigator.language.includes("es")) {
        trans = language.es;
        document.getElementsByTagName("html")[0].setAttribute("lang", "es");
        translate = true;
        aEn.className = aEn.className.replace(" set", "");
        aEs.className += " set";
    } else trans = language.eng;
    if (translate) {
        menuLang.textContent = trans.idiom;
        modalMessage.textContent = trans.messageLogout;
        loginInst.textContent = trans.initSession;
        btnPhoneLogin.textContent = trans.phone;
        btnEmailLogin.textContent = trans.email;
        etEmail.placeholder = trans.email;
        etPassword.placeholder = trans.password;
        emailOptions.querySelector("label").textContent = trans.remember;
        btnLogin.textContent = trans.login;
        emailOptions.querySelector("p").innerHTML = trans.disclaimer;
    }
}

},{"./common":"loJev"}]},["4DmIA"], "4DmIA", "parcelRequire460e")

//# sourceMappingURL=login.78d1c087.js.map
